import PageHero from '@/components/PageHero';
import { GlassCard } from '@/components/ui/glass-card';
import { Link } from 'react-router-dom';
import { 
  Calendar, 
  Heart, 
  FileText, 
  Info, 
  Handshake, 
  Leaf,
  ArrowRight
} from 'lucide-react';

const Mehr = () => {
  const pages = [
    {
      title: "Anmeldung",
      description: "Melden Sie sich für die Prana Kundalini-Therapie® Ausbildung an",
      icon: Calendar,
      href: "/anmeldung",
      color: "text-blue-600"
    },
    {
      title: "Behandlungen",
      description: "Erfahren Sie mehr über unsere energetischen Behandlungen",
      icon: Heart,
      href: "/behandlungen",
      color: "text-red-500"
    },
    {
      title: "AGB",
      description: "Allgemeine Geschäftsbedingungen für unsere Ausbildungen",
      icon: FileText,
      href: "/agb",
      color: "text-gray-600"
    },
    {
      title: "Impressum",
      description: "Rechtliche Informationen und Kontaktdaten",
      icon: Info,
      href: "/impressum",
      color: "text-gray-700"
    },
    {
      title: "Kooperationen",
      description: "Unsere Partner und Kooperationsmöglichkeiten",
      icon: Handshake,
      href: "/kooperationen",
      color: "text-green-600"
    },
    {
      title: "Lebenswerkstätten",
      description: "Workshops und Veranstaltungen für ganzheitliche Entwicklung",
      icon: Leaf,
      href: "/lebenswerkstaetten",
      color: "text-emerald-600"
    }
  ];

  return (
    <>
      <PageHero 
        title="Mehr" 
        description="Weitere Informationen und Services der Prana Kundalini Akademie"
        image="https://images.unsplash.com/photo-1523712999610-f77fbcfc3843"
      />
      
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {pages.map((page, index) => {
              const IconComponent = page.icon;
              
              return (
                <Link key={index} to={page.href} className="group block">
                  <GlassCard className="p-8 h-full hover:scale-105 transition-all duration-300 hover:shadow-2xl">
                    <div className="text-center space-y-4">
                      <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 group-hover:bg-primary-lightest/30 transition-colors ${page.color}`}>
                        <IconComponent className="h-8 w-8" />
                      </div>
                      
                      <h3 className="text-xl font-bold text-primary-deep group-hover:text-primary-main transition-colors">
                        {page.title}
                      </h3>
                      
                      <p className="text-gray-600 leading-relaxed">
                        {page.description}
                      </p>
                      
                      <div className="flex items-center justify-center space-x-2 text-primary-main group-hover:text-primary-deep transition-colors">
                        <span className="font-medium">Mehr erfahren</span>
                        <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                      </div>
                    </div>
                  </GlassCard>
                </Link>
              );
            })}
          </div>

          {/* Contact Section */}
          <div className="mt-16">
            <GlassCard className="p-8 max-w-3xl mx-auto text-center">
              <h3 className="text-2xl font-bold text-primary-deep mb-4">
                Haben Sie noch Fragen?
              </h3>
              <p className="text-gray-700 mb-6">
                Zögern Sie nicht, uns zu kontaktieren. Wir sind gerne für Sie da und 
                helfen Ihnen bei allen Fragen rund um die Prana Kundalini-Therapie® Ausbildung.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a 
                  href="mailto:sabrina.kure@yahoo.com"
                  className="inline-flex items-center justify-center px-6 py-3 bg-primary-main hover:bg-primary-deep text-white rounded-lg font-medium transition-colors"
                >
                  <span className="mr-2">✉️</span>
                  E-Mail schreiben
                </a>
                
                <a 
                  href="tel:+436649703314"
                  className="inline-flex items-center justify-center px-6 py-3 border border-primary-main text-primary-main hover:bg-primary-main hover:text-white rounded-lg font-medium transition-colors"
                >
                  <span className="mr-2">📞</span>
                  Anrufen
                </a>
                
                <a 
                  href="https://wa.me/436649703314" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center px-6 py-3 bg-green-500 hover:bg-green-600 text-white rounded-lg font-medium transition-colors"
                >
                  <span className="mr-2">💬</span>
                  WhatsApp
                </a>
              </div>
            </GlassCard>
          </div>
        </div>
      </section>
    </>
  );
};

export default Mehr;